import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { ConfirmationModal } from '../confirmationModal';

const Delete = ({ data, closeDialog, onDelete }) => {
    const [deleteData, setDeleteData] = useState({});

    useEffect(() => {
        if (data) setDeleteData(data);
    }, [data]);

    return (
        <ConfirmationModal
            header={`Delete ${deleteData?.environment ?? ''} - ${deleteData?.deploymentType ?? ''}`}
            body={'Are you sure you wish to delete this deployment?'}
            confirmButtonText={'Delete'}
            confirmButtonProps={{ appearance: 'primary', text: true }}
            closeDialog={closeDialog}
            onConfirm={onDelete}
        />
    );
};

Delete.propTypes = {
    onDelete: PropTypes.func.isRequired,
    data: PropTypes.object,
    closeDialog: PropTypes.func.isRequired
};

export default Delete;
